export const CHART_COLORS = [
  '#2D6A4F',
  '#49A35B',
  '#40916C',
  '#6BBF7B',
  '#377F56',
  '#74C69D',
  '#1B4332',
  '#95D5A0',
  '#B7E4C7',
  '#D8F3DC',
];

export const NAV_ITEMS = [
  { id: 'inicio', label: 'Inicio', icon: 'grid' },
  { id: 'clientes', label: 'Ventas por Cliente', icon: 'users', premium: true },
  { id: 'productos', label: 'Ventas por Producto', icon: 'package', premium: true },
];

export const MOCK_SALES = {
  month: '2026-02',
  clients: [
    { name: 'Restaurant Luna', total: 6840 },
    { name: 'Cafeteria Solaris', total: 4520 },
    { name: 'Hotel Pacifica', total: 3180 },
    { name: 'Bar Centenario', total: 2750 },
    { name: 'Bistro Nacional', total: 1920 },
    { name: 'Otros', total: 1340 },
  ],
  total: 20550,
};
